import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import DeleteIcon from '@components/Icon/Delete'
import Action from '@components/Action'
import AddIcon from '@components/Icon/Add'
import { StatusLabel } from '@components/StatusLabel'
import { formatDate, formatNumber } from '@atheneum/api/dist/lib'
import InvoiceOverpaidNotification from './Components/InvoiceOverpaidNotification'
import { showDialog, isCancellationError } from '@components/Dialog'
import ACL from '@components/ACL'
import {
  isInvoiceOverpaid,
  calculateTotalAndRemainingAmount
} from './calculateInvoiceAmount'

class InvoicePayments extends Component {
  static propTypes = {
    className: PropTypes.string,
    invoice: PropTypes.object,
    staticData: PropTypes.object,
    invoiceStore: PropTypes.object,
    onAddInvoicePayment: PropTypes.func,
    growlStore: PropTypes.object
  }

  removeInvoicePayment = invoicePayment => {
    const { invoiceStore } = this.props
    const { invoice } = invoiceStore

    const title = 'Remove this invoice payment from invoice?'

    return showDialog({
      title,
      // text: invoicePayment.description,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    })
      .then(() =>
        invoiceStore.removeInvoicePayment(invoice.id, invoicePayment.id)
      )
      .catch(error => {
        if (isCancellationError(error)) return
        const { growlStore } = this.props
        growlStore.showError(error)
      })
  }

  renderActions = () => {
    const actions = (
      <ul className='actions right-list'>
        <ACL roles={['Accounting', 'Admin']} action>
          <Action alignRight>
            <li
              onClick={this.props.onAddInvoicePayment}
              data-cy='add-payment-btn'
            >
              <AddIcon />
              <span>Add payment</span>
            </li>
          </Action>
        </ACL>
      </ul>
    )

    return (
      <div className='actions-wrapper'>
        {actions}
        <ul className='actions left-list'>
          <h2>Invoice payments</h2>
        </ul>
      </div>
    )
  }

  renderNoPayments = () => {
    return (
      <div className={this.props.className}>
        {this.renderActions()}
        <h3 className='no-content-message'>No payments</h3>
      </div>
    )
  }

  renderInvoicePayments = (staticData, invoice) => {
    const invoiceCurrency = staticData.names.currencies[invoice.currencyId]

    const payments = invoice.invoicePayments.map(payment => (
      <tr key={payment.id}>
        <td>
          <span className='m-r-md'>{formatDate(payment.paidDate)}</span>
          <StatusLabel
            statusId={payment.invoicePaymentStatusId}
            statusesType='invoicePaymentStatuses'
          />
        </td>
        <td className='right'>
          {formatNumber(payment.amount)} {invoiceCurrency}
        </td>
        <td className='invoice__icon-container'>
          <ACL roles={['Accounting', 'Admin']} action>
            <DeleteIcon onClick={() => this.removeInvoicePayment(payment)} />
          </ACL>
        </td>
      </tr>
    ))

    const { totalPayments, remaining } = calculateTotalAndRemainingAmount(
      invoice
    )
    const remainingClasses = isInvoiceOverpaid(invoice)
      ? 'title red-text'
      : 'title'

    return (
      <div className={this.props.className}>
        {this.renderActions()}

        <InvoiceOverpaidNotification
          invoice={invoice}
          invoicePayments={invoice.invoicePayments}
        />

        <table className='table-wrapper--nested invoice-table'>
          <thead>
            <tr>
              <th>Date received</th>
              <th className='right'>Amount</th>
              <th className='invoice__icon-container' />
            </tr>
          </thead>
          <tbody>{payments}</tbody>
          <tfoot>
            <tr className='title'>
              <td>Total</td>
              <td className='right'>
                {formatNumber(totalPayments)} {invoiceCurrency}
              </td>
              <td className='invoice__icon-container' />
            </tr>
            <tr className={remainingClasses}>
              <td>Remaining</td>
              <td className='right'>
                {formatNumber(remaining)} {invoiceCurrency}
              </td>
              <td className='invoice__icon-container' />
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  render () {
    const { invoice, staticData } = this.props
    const { INVOICE_STATUSES } = staticData.CONST

    if (invoice.invoiceStatusId < INVOICE_STATUSES.CREATED) return null

    if (!invoice.invoicePayments || invoice.invoicePayments.length === 0) {
      return this.renderNoPayments()
    }

    return this.renderInvoicePayments(staticData, invoice)
  }
}

export default inject(
  'staticData',
  'invoiceStore',
  'growlStore'
)(observer(InvoicePayments))
